/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./style.css";
export interface IPaginationProps {
  current: number;
  pageSize: number;
  onChange?: (pagination: {
    current: number;
    pageSize: number;
    offset: number;
  }) => void;
  length?: number;
  loading?: boolean;

}

const Pagination = ({
  current,
  onChange,
  pageSize,
  length,
  loading
}: IPaginationProps) => {
  

  const prevDisabled = current <= 1 ||loading;
  const nextDisabled = ((length && length < 20) || length === 0) || loading;
  return (
    <div className="ad-pagination">
      Page: {current || 1}
      <a
        data-disabled={prevDisabled}
        onClick={() => {
          !prevDisabled &&
            onChange &&
            onChange({
              current: current > 1 ? current - 1 : 1,
              offset: (current - 1) * pageSize,
              pageSize,
            });
        }}
      >
        Prev
      </a>
      <a
        data-disabled={nextDisabled}
        onClick={() => {
          !nextDisabled &&
            onChange &&
            onChange({
              current: current + 1,
              offset: (current - 1) * pageSize,
              pageSize,
            });
        }}
      >
        Next
      </a>
    </div>
  );
};

export { Pagination };
